import DashboardContainer from 'components/PageContainer/DashboardContainer';
import FormUsuario from 'components/public/FormUsuario/FormUsuario';

const DatosCuenta = () => {
  return (
    <DashboardContainer>
      <FormUsuario titulo="Edición datos personales" variante="edicionUsu" textoBoton="Actualizar" />
    </DashboardContainer>
  );
};

export default DatosCuenta;
